import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const SelectFilter = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  "& .css-1s1upiv-control , & .css-1s79at0-control": {
    width: "160px",
  },
}));
const FilterMain = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "15px",
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    paddingRight: "20px",
  },
}));
const OrderFilterMain = styled("div")(({ theme }) => ({
  marginBottom: "20px",
  display: "flex",
  WebkitBoxDirection: "normal",
  flexDirection: "row",
  // width: "100%",
  gap: "15px",
  paddingBottom: "10px",
  [theme.breakpoints.down("md")]: {
    overflow: "auto",
    overflowY: "hidden",
    paddingTop: "20px",
    scrollBehavior: "smooth",
  },
}));
const FilterButton = styled(Button)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "16px",
  color: "#6B6B6B",
  fontFamily: theme.typography.fontFamily,
  background: "#FFFFFF",
  border: "1px solid #6B6B6B",
  borderRadius: "50px",
  padding: "7px 15px",
  textTransform: "capitalize",
  "&.active": {
    background: "#0B0B0B",
    color: "#fff",
    border: "1px solid #0B0B0B",
    fontWeight: 600,
    fontSize: "14px",
  },
  [theme.breakpoints.down("md")]: {
    minWidth: "fit-content",
  },
}));

export { OrderFilterMain, FilterButton, FilterMain, SelectFilter };
